import axios from "axios";
import { authHelper } from "src/stores/helpers";

export const getAxiosClient = (baseUrl: string) => {
  const axiosClient = axios.create({
    baseURL: baseUrl,
  });

  axiosClient.interceptors.request.use(
    async (axiosConfig) => {
      let token = null;
      token = await authHelper.getAuth0Functions().getAccessTokenSilently();

      if (token) {
        // @ts-ignore
        axiosConfig.headers.Authorization = `Bearer ${token}`;
      }

      axiosConfig.validateStatus = (status: number) =>
        (status >= 200 && status < 300) || status == 404; // https://github.com/axios/axios?tab=readme-ov-file#handling-errors

      return axiosConfig;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return axiosClient;
};
